import { createImmutableSliceSelector } from './utils';
export const selectConnectedForms = createImmutableSliceSelector('connectedForms');